
import { useEffect, useState } from 'react';
import { Trip } from '@/types/itinerary';
import { TripStats } from './tripTypes';

export const useTripStats = (trips: Trip[]) => {
  const [stats, setStats] = useState<TripStats>({
    totalTrips: 0,
    upcomingTrips: 0
  });

  // Effect to calculate trip statistics
  useEffect(() => {
    if (trips.length > 0) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const upcoming = trips.filter(trip => {
        const startDate = new Date(trip.start_date);
        return startDate >= today;
      });
      
      setStats({
        totalTrips: trips.length,
        upcomingTrips: upcoming.length
      });
    } else {
      setStats({
        totalTrips: 0,
        upcomingTrips: 0
      });
    }
  }, [trips]);

  return stats;
};
